<template xmlns="http://www.w3.org/1999/html">
    <div
        style="height: 100vh;display: flex;flex-direction: column;background-color: rgb(18,73,39);align-items: center;justify-content:space-between;overflow:scroll;">
        <img src="/static/images/tianyi/logo.png" style="position: absolute;top:3vh;width: 40vw;">
        <div
            style="width: 92vw;background-color: rgb(242, 242, 242);height: 40vh;border-radius: 15px;position: absolute;top:12vh">
            <div style="width: 100%;height: 82%;background-color: white;border-radius: 15px;display: flex;">
                <div style="height: 100%;width: 63%;display: flex;flex-direction: column;">
                    <img src="/static/images/tianyi/scxx.png" style="width: 40%;margin-top: 3vh;margin-left: 2vh;">
                    <span style="color: rgb(58, 58, 58);font-size: 2.8vw;margin-left: 2vh;margin-top: 1vh;">查询数码：{{
                        antiCode.substring(0, 16) }}</span>
                    <span style="color: rgb(58, 58, 58);font-size: 2.8vw;margin-left: 2vh;margin-top: 1vh;">产品名称：{{
                        productName }}</span>
                    <span style="color: rgb(58, 58, 58);font-size: 2.8vw;margin-left: 2vh;margin-top: 1vh;">原生产地：中国台湾省
                    </span>
                    <div style="height: 0;margin-top: 1vh;"></div>
                    <hr
                        style="border: none; height: 1px;margin-left: 2vh;background-color: rgb(224, 224, 224);width: 85%;" />
                    <img src="/static/images/tianyi/zsmcs.png" style="width: 65%;margin-top: 2vh;margin-left: 2vh;">
                    <span style="color: rgb(58, 58, 58);font-size: 2.8vw;margin-left: 2vh;margin-top: 1vh;">首次扫码：{{
                        firstQueryTime }}</span>
                    <span style="color: rgb(58, 58, 58);font-size: 2.8vw;margin-left: 2vh;margin-top: 1vh;">最新扫码：{{
                        preQueryTime }}
                    </span>
                </div>
                <div v-if="productNo == 'hblsd'" style="height: 102%;width: 37%;position: relative;">
                    <img src="/static/images/tianyi/old.png"
                        style="height:48%;position: absolute;bottom: 0;left: -3vw;">
                </div>
                <div v-if="productNo == 'hblsdtl'" style="height: 100%;width: 37%;position: relative;">
                    <img src="/static/images/tianyi/tl.png"
                        style="height:90%;position: absolute;bottom: -2vh;left: -3vw;">
                </div>
                <div v-if="productNo == 'zhsgd'" style="height: 100%;width: 37%;position: relative;">
                    <img src="/static/images/tianyi/yjz.png"
                        style="height:90%;position: absolute;bottom: 0;">
                </div>
                <div v-if="productNo == 'jss'" style="height: 100%;width: 37%;position: relative;">
                    <img src="/static/images/tianyi/jss.png"
                        style="height:80%;position: absolute;bottom: 0;left: -3vw;">
                </div>


            </div>


            <div
                style="width: 100%;text-align: center;height: 18%;display: flex;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/lqjf.png" style="width: 30%;" @click="getjf">
            </div>


        </div>


        <div
            style="width: 92vw;height: 24vh;position: absolute;top:52vh;margin-top: 3vh;display: flex;justify-content: space-between;">
            <div
                style="width: 48%;height: 100%;background-color: white;position: relative;;border-radius: 10px;display: flex;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/left.png" style="width: 90%;position: absolute;left: 3vw;">

                <div style="width: 95%; height: 4vh; position: absolute; bottom: 2.5vw; left: 3.8vw;">
                    <img src="/static/images/tianyi/djlq.png" style="width: 45%;" @click="addWecom">
                </div>
            </div>
            <div
                style="width: 48%;height: 100%;background-color: white;position: relative;;border-radius: 10px;display: flex;align-items: center;justify-content: center;overflow-x: hidden;">
                <img v-if="productNo=='hblsd' || productNo=='hblsdtl'" src="/static/images/tianyi/right.png" style="height: 95%;position: absolute;bottom: 0;left: 4vw;">
                <img v-if="productNo=='zhsgd'" src="/static/images/tianyi/right2.png" style="height: 90%;position: absolute;bottom: 1vw;left: 3vw;">
                <img v-if="productNo=='jss'" src="/static/images/tianyi/right3.png" style="height: 90%;position: absolute;bottom: 1vw;left: 3vw;">
                <wx-open-launch-weapp id="launch-btn"
                    style="width: 95%; height: 4vh; position: absolute; bottom: 2.5vw; left: 3.8vw;" :appid="miniAppId"
                    :username="miniAppOriginalId" :path="miniAppPage">
                    <script type="text/wxtag-template">
                        <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/jrhy.png"  style="width: 45%;" />
                    </script>
                </wx-open-launch-weapp>
            </div>
        </div>


        <div
            style="width: 88vw;height: 18vh;position: absolute;top:76vh;margin-top: 3vh;display: flex;align-items: center;justify-content: space-between;">
            <img src="/static/images/tianyi/zpbz.png" style="height: 10vh;">
            <img src="/static/images/tianyi/zyfw.png" style="height: 10vh;">
            <img src="/static/images/tianyi/bysd.png" style="height: 10vh;">
            <img src="/static/images/tianyi/pzsy.png" style="height: 10vh;">

        </div>

        <div v-show="isShow">
            <div id="fixedBg"></div>
            <p class="loading_p" id="loadP">
                <img src="/static/images/loadding.gif" />
            </p>
        </div>





        <div id="background" style="z-index: 2;" v-if="showWeCom">
            <div id="jfwin" class="modalwin" @click="closeWeCom"></div>
            <img src="/static/images/tianyi/addwecom.png"
                style="position:absolute;width: 80vw;z-index: 5;top: 30vh;left: 12vw;" />


        </div>

        <div id="background" style="z-index: 2;" v-if="showUnbindProductDialog">
            <div id="jfwin" class="modalwin" @click="closeUnbindProduct"></div>
            <img src="/static/images/tianyi/failjf.png"
                style="position:absolute;width: 80vw;z-index: 5;top: 30vh;left: 12vw;user-select: none;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;" />
            <div
                style="position:absolute;width: 100vw;z-index: 5;top: 30vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/jflqtip.png"
                    style="width: 50vw;z-index: 5;margin-top: 7vh;margin-left: -2.8vw;" />
                <img src="/static/images/tianyi/qrcode.png"
                    style="width: 33vw;z-index: 5;margin-top: 1vh;margin-left: -2.8vw;" />
                <img src="/static/images/tianyi/changan.png"
                    style="width: 33vw;z-index: 5;margin-top: 1vh;margin-left: -2.8vw;" />
            </div>
            <!-- 
                
                 -->
        </div>


        <div id="background" style="z-index: 2;" v-if="showJfDialog">
            <div id="jfwin" class="modalwin" @click="closeJfDialog"></div>

            <div
                style="position:absolute;width: 100vw;z-index: 6;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/jfpoup.png" style="width: 90vw;margin-left: 3vw;" />
                <wx-open-launch-weapp id="launch-btn"
                    style="width: 30vw; height: 5vh; position: absolute;z-index: 5;bottom: 1vh;" :appid="miniAppId"
                    :username="miniAppOriginalId" :path="miniAppPage">
                    <script type="text/wxtag-template">
                        <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/ljdh.png"  style="width: 100%;" />
                    </script>
                </wx-open-launch-weapp>
            </div>
            <div
                style="position:absolute;width: 100vw;z-index: 5;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/sun.png" style="width: 100vw;" />
            </div>
            <div
                style="position:absolute;width: 100vw;z-index: 6;top: 31vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/jflogo.png" style="width: 30vw;z-index: 5;" />
                <div style="margin-top: 0.3vh;display: flex;align-items: center;justify-content: center;">
                    <span style="font-size: 9vw;font-weight:bold;color: rgb(35, 72, 42);margin-top: -0.2vh;">{{ jfValue
                        }}</span>&nbsp;
                    <img src="/static/images/tianyi/jftext.png" style="width: 14vw;z-index: 5;" />
                </div>
            </div>
        </div>



        <div id="background" style="z-index: 2;" v-if="showJfCFDialog">
            <div id="jfwin" class="modalwin" @click="closeJfCFDialog"></div>

            <div
                style="position:absolute;width: 100vw;z-index: 6;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/jfcflq.png" style="width: 90vw;margin-left: 3vw;" />
                <wx-open-launch-weapp id="launch-btn"
                    style="width: 30vw; height: 5vh; position: absolute;z-index: 5;bottom: 1vh;" :appid="miniAppId"
                    :username="miniAppOriginalId" :path="miniAppPage">
                    <script type="text/wxtag-template">
                        <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/ljdh.png"  style="width: 100%;" />
                    </script>
                </wx-open-launch-weapp>
            </div>
            <div
                style="position:absolute;width: 100vw;z-index: 5;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="/static/images/tianyi/sun.png" style="width: 100vw;" />
            </div>

        </div>
    </div>
</template>
<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.modalwin {
    position: relative;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    /* 固定位置 */
    z-index: 4;
    /* 位于顶层 */
    left: 0;
    top: 0;
    width: 100vw;
    /* 宽度全屏 */
    height: 100vh;
    /* 高度全屏 */
    overflow: hidden;
    background-color: rgba(3, 3, 3, 0.6);
    /* 超出内容可滚动 */
}
</style>

<script>
import { antiQuery, getInfoByCode, getJSSDK, getTemplate, getWechatAuth, registerByOpenId, joinActivity } from '../../api/api'
import wx from 'weixin-js-sdk'
import moment from 'moment';

export default {
    data() {
        return {
            isShow: false,
            showWeCom: false,
            eno: "138707141135",
            showJfDialog: false,
            deptId: "",
            authCode: "",
            antiCode: "",
            firstQueryTime: "",
            preQueryTime: "",
            jfValue: 0,
            productName: "",
            productNo: "",
            miniAppId: "wx64ce7aa94b232424",
            miniAppOriginalId: "gh_4bd8f3695d61",
            miniAppPage: "pages/home/dashboard/index",
            showUnbindProductDialog: false,
            showJfCFDialog: false,
        }
    },
    methods: {
        addWecom() {
            this.showWeCom = true
        },
        getjf() {
            if (this.productNo == null || this.productNo == undefined) {
                this.showUnbindProductDialog = true
            } else {
                this.joinActivity()
            }

        },
        closeUnbindProduct() {
            this.showUnbindProductDialog = false
        },
        closeJfDialog() {
            this.showJfDialog = false
        },
        closeJfCFDialog() {
            this.showJfCFDialog = false
        },
        closeWeCom() {
            this.showWeCom = false
        },
        async getResult() {
            this.isShow = true
            const params = this.$route.query;
            const code = params.c
            this.antiCode = code
            this.authCode = params.wyAuthCode
            var antiResult = await antiQuery(this.eno, code)
            var data = antiResult.data;
            if (data == null || data.code == "500") {
                this.isShow = false
                alert("防伪查询失败,请联系管理员");
            } else if (data.code == "300106") {
                this.isShow = false
                alert(data.message);
            } else {
                var codeInfo = await getInfoByCode(code)
                this.isShow = false

                this.firstQueryTime = data.data.firstQueryTime
                if (data.code == "300101") {
                    this.preQueryTime = data.data.firstQueryTime
                } else {
                    this.preQueryTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                }
                this.deptId = data.data.deptId
                this.productName = codeInfo.data.data.productName
                this.productNo = codeInfo.data.data.productNo
                const isCliskJf = sessionStorage.getItem("clickJf");
                if (isCliskJf == "true") {
                    this.joinActivity()
                }
            }
            this.isShow = false
        },
        getAuth() {
            const url = window.location.href.split('#')[0];
            getWechatAuth(url, "wx8ae619a1dbc50c9e", 1).then(res => {
                const data = res.data;
                window.location.href = data;
            }).catch(err =>
                alert("获取微信授权失败" + err)
            )
        },
        async getScoreConfig() {
            // const res = await getScoreConfig(this.deptId)
            // if (res.data.data != null) {
            //     this.shopUrl = res.data.data.shopUrl
            //     const data = this.shopUrl.split('|')
            //     this.miniAppId = data[0]
            //     this.miniAppOriginalId = data[1]
            //     this.miniAppPage = data[2]
            // }
        },
        async getTemplate() {
            const res = await getTemplate(this.deptId)
            if (res.data.data != null) {
                this.activityId = res.data.data.activityId
            }
        },
        async joinActivity() {
            await this.getTemplate()

            if (this.activityId == 0 || this.activityId == "" || this.activityId == null || this.activityId == undefined) {
                alert("此活动已结束")
            } else {
                //发起用户授权
                if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
                    sessionStorage.setItem("clickJf", true);
                    this.getAuth()
                    return;
                }
                //用户注册
                const registerResult = await registerByOpenId(this.eno, this.authCode)
                if (registerResult.data.code == "500") {
                    alert("用户登录异常，请联系管理员")
                    return
                } else {
                    this.userToken = registerResult.data.data.token
                }
                const data = {
                    code: this.antiCode,
                    activityId: this.activityId,
                    authCode: this.authCode,
                    userToken: this.userToken
                }
                const result = await joinActivity(data)
                sessionStorage.removeItem("clickJf");
                if (result.data.code == "200") {
                    this.jfValue = result.data.data.giftValue
                    this.showJfDialog = true
                } else if (result.data.code == "500001") {
                    this.showJfCFDialog = true
                } else if (result.data.code == "500") {
                    alert("系统异常，请稍后再试")
                }

            }


        },
        getWxJs() {
            const url = encodeURIComponent(window.location.href.split('#')[0])
            getJSSDK(url, "wx8ae619a1dbc50c9e").then(res => {
                const data = res.data.data
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名，见附录1
                    openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
                    jsApiList: [
                        'checkJsApi',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'hideMenuItems',
                        'showMenuItems',
                        'hideAllNonBaseMenuItem',
                        'showAllNonBaseMenuItem',
                        'translateVoice',
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'chooseImage',
                        'previewImage',
                        'uploadImage',
                        'downloadImage',
                        'getNetworkType',
                        'openLocation',
                        'getLocation',
                        'hideOptionMenu',
                        'showOptionMenu',
                        'closeWindow',
                        'scanQRCode',
                        'chooseWXPay',
                        'openProductSpecificView',
                        'addCard',
                        'chooseCard',
                        'openCard'
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    wx.hideMenuItems({
                        menuList: [
                            'menuItem:copyUrl',
                            'menuItem:openWithQQBrowse',
                            'menuItem:openWithSafari',
                            'menuItem:email',
                            'menuItem:readMode',
                            'menuItem:originPage',
                            'menuItem:delete',
                            'menuItem:editTag'
                        ]
                    });
                });

            }).catch(err =>
                alert("获取微信授权失败" + err)
            )
        }
    },
    created: function () {
        this.getWxJs()
        this.getResult()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/TianYi/Index.vue